import { FC, PropsWithChildren } from 'react';
import { PageSizer } from './PageSizer';

interface Props extends PropsWithChildren {
}

export const ContentSection: FC<Props> = ({ children }) => {
  return (
    <div className="w-full relative">
      <PageSizer className="py-10">
        <div className="relative bg-white px-10 py-6 rounded-md border text-primary-800">{children}</div>
      </PageSizer>
    </div>
  );
};
